"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PdfCustomizationModal_1 = __importDefault(require("./PdfCustomizationModal"));
exports.default = PdfCustomizationModal_1.default;
